import React, { Component } from 'react';
import { Input } from 'antd';
import { calcGST } from 'store/utility';
import { connect } from 'react-redux';

class PriceSaleInput extends Component {
  constructor(props) {
    super(props);

    const value = props.value || {};
    this.state = {
      price_sale: value.price_sale || 0,
      gst: value.gst || 0,
      price_sale_gst: value.price_sale_gst || '$0.00',
    };
  }

  componentDidMount() {
    const { settings, value } = this.props;
    if (!settings || !value) {
      return;
    }

    let gst = value.gst || 0;
    let price_sale = value.price_sale ? value.price_sale : 0;

    if (!gst) {
      gst = 0;
    }

    if (!price_sale) {
      price_sale = 0;
    }

    this.setState({
      gst: gst,
      price_sale: price_sale,
      price_sale_gst: calcGST(price_sale * 100, gst),
    });
  }

  componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      const { value } = nextProps;
      this.setState(prev => ({ ...prev, ...value }));
    }
  }

  priceChangeHandler = e => {
    const price_sale = parseFloat(e.target.value || 0, 10);
    const price_sale_gst = calcGST(price_sale * 100, this.props.value.gst);
    if (!('value' in this.props)) {
      this.setState(prev => ({ ...prev, price_sale, price_sale_gst }));
    } else {
      // this.setState(prev => ({ ...prev, price_sale_gst }));
    }
    this.triggerChange({ price_sale, price_sale_gst });
  };

  triggerChange = changedValue => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };

  gstChangeHandler = e => {
    const gst = parseFloat(e.target.value || 0, 10);
    const price_sale_gst = calcGST(this.state.price_sale * 100, gst);
    if (!('value' in this.props)) {
      this.setState(prev => ({ ...prev, gst: gst, price_sale_gst }));
    }

    this.triggerChange({ gst: gst, price_sale_gst });
  };

  render() {
    return (
      <div>
        <div>
          <Input
            defaultValue={'' + this.state.price_sale}
            onChange={this.priceChangeHandler}
            style={{ width: '100px', marginRight: '3%' }}
            disabled={this.props.disabled}
          />
          <Input onChange={this.gstChangeHandler} value={this.state.gst} style={{ width: '50px' }} disabled={true} />
          <span> %</span>
        </div>
        <div>
          <span>Total: w/ GST: {this.state.price_sale_gst}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    settings: state.setting.settings,
  };
};

export default connect(mapStateToProps)(PriceSaleInput);



// WEBPACK FOOTER //
// ./src/components/QRcode/Input/PriceSaleInput.js